import { Store } from 'vuex';
import axios, { AxiosPromise } from 'axios';

export default class LoginService {
  constructor(public cookie: any, public store: Store<{}>) {}

  public goToLogin(residenceCountryCode: string, issuer: string, loc = window.location) {
    const port = loc.port ? ':' + loc.port : '';
    const contextPath = `/login/${residenceCountryCode}/${issuer}/`;
    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.
    // loc.href = `//${loc.hostname}${port}${contextPath}oauth2/authorization/oidc`;

    this.cookie.set('issuer', issuer);
    this.cookie.set('finalRedirectUri', `${contextPath}`);
    loc.href = `//${loc.hostname}${port}/oauth2/authorization/oidc`;
  }

  public goToRegister(residenceCountryCode: string, issuer: string, loc = window.location) {
    const contextPath = `/login/${residenceCountryCode}/${issuer}/`;

    this.cookie.set('finalRedirectUri', `${contextPath}`);
    this.getRegisterRul(`${loc.origin}/visa/${residenceCountryCode}/${issuer}/home`, issuer).then(res => {
      if (res) {
        loc.href = res;
      }
    });
  }

  public getRegisterRul(redirectUrl: string, issuer: string): Promise<any> {
    return axios.get('/api/register-url', { params: { redirectUrl, issuer } }).then(res => res.data);
  }

  public logout(): AxiosPromise<any> {
    return axios.post('api/logout');
  }
}
